import React, { useEffect, useState } from "react";
import { find } from "lodash";
import { Field } from "formik";

import useAxios from "hooks/useAxios";
import FormikSelectField from "components/common/Fields/FormikSelectField";

const CoveredEntity = ({ orgId, onChange, setCEList, ...rest }) => {
  const API = useAxios();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [coveredEntitiesData, setCoveredEntitiesData] = useState([]);

  useEffect(() => {
    if (orgId) {
      fetchCoveredEntity();
    }
  }, [orgId]);

  const fetchCoveredEntity = async () => {
    setLoading(true);
    let { organizationID } = orgId || {};
    console.log(organizationID, "org");
    if (organizationID != -1) {
      let selectedOrgId = orgId?.organizationID;
      console.log(window.selectedCoveredEntittyId, "window");

      console.log(selectedOrgId);
      try {
        const { data } = await API.get(
          `RCMConfig/coveredentity/list/${selectedOrgId}`,
          {
            hasDefaultURL: true,
          }
        );
        setLoading(false);
        setData(data);
        if (data) {
          const CeData = data.map((item) => ({
            id: item.coveredEntityID,
            label: item.coveredEntityName,
          }));
          console.log(data, "data");
          const entity = data[0];
          if (setCEList) {
            setCEList(CeData);
          }
          setCoveredEntitiesData(CeData);
          if (CeData.length == 1) {
            onChange(CeData[0].id, entity);
          } else if (window.selectedCoveredEntittyId) {
            const filter = data.filter(
              (item) => item.coveredEntityID == window.selectedCoveredEntittyId
            );
            const entityobj = filter[0] ? filter[0] : data("");
            onChange(window.selectedCoveredEntittyId, entityobj);

          } else {
            console.log("krishna");
          }
        }
      } catch (err) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchCoveredEntity();
  }, []);
  const coveredEntity = loading ? [] : data || [];

  const handleChange = ({ target: { value } }) => {
    if (value) {
      const entity = find(coveredEntity, {
        coveredEntityID: parseInt(value),
      });
      onChange(value, entity);
    } else {
      onChange(value, "");
    }
  };
  return (
    <Field
      name="coveredEntityName"
      type="text"
      component={FormikSelectField}
      options={coveredEntitiesData}
      defaultoption="--Select--"
      className="required"
      keys={{
        id: "id",
        label: "label",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
};

export default CoveredEntity;

